/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMegaMenu = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsMegaMenu = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const parentLink = this.parent_link;
    const sectionId = this.section_id;
    const $megaMenu = $section.find('.mega-menu__' + sectionId);
    const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
    const $parentElementLink = $parentElement.find('.header__link');
    // Remove old mega menus
    $parentElement.find('.mega-menu__section').remove();

    // Mobile Selectors
    const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${parentLink}"]`);

    /* No submenu is present - add mega menu elements and caret */
    if ($parentMobileElement.find('.has-no-submenu').length) {

      // Assign class to display dropdown arrow
      $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link');

      // Insert the disclosure control after the menu item. This is a real
      // <button>, not a <span>: it is the only thing that opens the submenu, so
      // it has to be reachable and operable from the keyboard (GS-03). The
      // caret SVG is decorative once the button carries a name.
      var mobileLinkText = $.trim($parentMobileElement.find('a.mobile-menu__item').first().text()) || parentLink;
      var mobilePanelId = 'mobile-panel-' + parentLink;
      $parentMobileElement.find('a').after('<button type="button" class="close-dropdown" aria-expanded="false" aria-controls="' + mobilePanelId + '" aria-label="' + mobileLinkText + ' submenu"><svg aria-hidden="true" focusable="false" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.9023 1.12107L7.23583 8.39336C7.20487 8.42717 7.16811 8.45398 7.12764 8.47228C7.08718 8.49058 7.0438 8.5 7 8.5C6.9562 8.5 6.91282 8.49058 6.87236 8.47228C6.83189 8.45398 6.79513 8.42717 6.76417 8.39336L0.0976826 1.12107C0.0667133 1.08729 0.0421472 1.04718 0.0253868 1.00304C0.00862633 0.958903 0 0.911594 0 0.863817C0 0.81604 0.00862633 0.76873 0.0253868 0.72459C0.0421472 0.68045 0.0667133 0.640343 0.0976826 0.606559C0.160228 0.538331 0.245058 0.5 0.33351 0.5C0.377307 0.5 0.420675 0.509411 0.461139 0.527694C0.501602 0.545978 0.538368 0.572776 0.569337 0.606559L7 7.62159L13.4307 0.606559C13.4616 0.572776 13.4984 0.545978 13.5389 0.527694C13.5793 0.509411 13.6227 0.5 13.6665 0.5C13.7103 0.5 13.7537 0.509411 13.7941 0.527694C13.8346 0.545978 13.8713 0.572776 13.9023 0.606559C13.9333 0.640343 13.9579 0.68045 13.9746 0.72459C13.9914 0.76873 14 0.81604 14 0.863817C14 0.911594 13.9914 0.958903 13.9746 1.00304C13.9579 1.04718 13.9333 1.08729 13.9023 1.12107Z" fill="currentColor"/></svg></button>');

      // Insert placeholder ul for megamenu, carrying the id the button controls
      $parentMobileElement.find('.submenu__label').after('<ul id="' + mobilePanelId + '" class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>')

      // Find data attribute for toggle and assign it true
      let $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
      $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true);


      // Insert mega menu
      let $parentList = $parentMobileElement.find('.has-mega-menu');
      $megaMenu.clone().appendTo($parentList);

    } else {
      /* Submenu is present - add mega menu elements and remove current sub-menu */
      let $parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');

      $parentList
        .empty()
        .addClass('has-mega-menu')
        .removeClass('has-dropdown');

      // Insert mega menu
      $megaMenu.clone().appendTo($parentList);
    }


    // Desktop
    if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
      // Hide default dropdown
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      // Add arrow to parent link to indicate dropdown
      $parentElementLink.removeClass('is-arrowless');

      $megaMenu.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');

      // Add/remove classes for proper styling and append mega menu instance
      $parentElement.addClass('has-mega-menu')
    }

    // Determine if header is set to hover to open or click to open
    if ($('.dropdown-click--false').length > 0) {
      $('.navbar-item, .header__brand, .header__search').on('mouseover', function(){

        //Close any mega menus on hover
        $('.mega-menu__section').removeClass('is-active');
        $('.header__item label').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
          $(this).find('label').addClass('is-active')
        }
      })

      $('.mega-menu__section, .navbar').on('mouseleave', function(){

        //Hide mega menu upon leaving mega menu, logo or navbar
        $('.mega-menu__section').removeClass('is-active');
        $('.header__item label').removeClass('is-active');
      })
    } else {
      $('.navbar-item, .header__brand, .header__search').on('click touchstart', function(){

        //Close any mega menus on click
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
        }
      })
    }
  },
  showThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  },
  hideMenu: function(id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  },
  unload: function($section) {
    let parentLink = $section.find('.mega-menu').data('parent-link');
    let navLink = $('[data-navlink-handle="' + parentLink + '"]')
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
  }
}

/******/ })()
;
